module.exports = __webpack_public_path__ + "img/12.d43e0946.webp";